export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/src/constant.js
// module id = A1w/
// module chunks = 0